import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import { CITIES, DIRECTORY_CATEGORIES } from "../../mock";
import { useContent } from "../../context/ContentContext";

export default function CitiesCategories() {
  const { c } = useContent();
  return (
    <>
      <section className="bg-[#f7f8fa] py-20 lg:py-24">
        <div className="mx-auto max-w-[1200px] px-5 lg:px-8">
          <p className="eyebrow">{c.cities.eyebrow}</p>
          <h2 className="font-display mt-3 text-[32px] font-extrabold tracking-tight text-[var(--ink)] sm:text-[40px]">{c.cities.title}</h2>
          <p className="mt-4 max-w-3xl text-[16px] leading-relaxed text-slate-500">{c.cities.description}</p>

          <div className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
            {CITIES.map((ct, i) => (
              <Link key={i} to={`/locations/${ct[2]}`} className="card-hover flex items-center justify-between rounded-xl border border-slate-200 bg-white px-4 py-3 text-[14px] transition-colors hover:border-[var(--brand-blue)]">
                <span className="flex items-center gap-2 font-medium text-[var(--ink)]">
                  <MapPin size={14} className="text-slate-400" />
                  {ct[0]}
                </span>
                <span className="text-[12px] font-semibold text-[var(--brand-blue)]">{ct[1]}</span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-white py-20 lg:py-24">
        <div className="mx-auto max-w-[1200px] px-5 lg:px-8">
          <p className="eyebrow">{c.categories.eyebrow}</p>
          <h2 className="font-display mt-3 text-[32px] font-extrabold tracking-tight text-[var(--ink)] sm:text-[40px]">{c.categories.title}</h2>
          <p className="mt-4 max-w-3xl text-[16px] leading-relaxed text-slate-500">{c.categories.description}</p>

          <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2">
            {DIRECTORY_CATEGORIES.map((cat, i) => (
              <Link key={i} to="/providers" className="group flex items-center justify-between rounded-xl border border-slate-200 bg-white px-5 py-4 text-[15px] font-medium text-[var(--ink)] transition-colors hover:border-[var(--brand-blue)] hover:bg-slate-50">
                {cat}
                <ArrowRight size={17} className="text-slate-300 transition-all group-hover:translate-x-1 group-hover:text-[var(--brand-blue)]" />
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
